import './shared';
import $ from 'jquery';
import redirector from 'mesitis/utils/redirector';
import kh from 'mesitis/utils/kendoHelper';
import us from 'mesitis/services/userService';
import bootbox from 'bootbox';
import ko from 'knockout';
import BaseViewModel from 'mesitis/baseViewModel';
import popupRenderer from 'mesitis/components/bsPopupRenderer';
import SessionObserver from 'mesitis/sessionObserver';
import NormalizationSessionObserver from 'mesitis/normalizationSessionObserver';
import userCardChangePwdComponent from 'mesitis/components/users/userCardChangePwdComponent';
import 'bootstrap';
import 'kendo';
import 'ko-plugins/ko.fadeVisible';

const config = (window as any).mesitisLayout || {};
const env = (window as any).mesitisEnv || {};

redirector.attachCsrf($, config.csrfToken);

$(function () {
    if (config.errorTooltip) {
        $('#errorInfoButton').kendoTooltip({
            content: config.errorTooltip,
        });
    }

    if (!(window as any).mesitisPageOwnsBindings && $('section').text().indexOf('ko.applyBindings') < 0) {
        if (!ko.dataFor(document.body)) {
            ko.applyBindings(new BaseViewModel());
        }
    }

    const $link = $('ul.nav.navbar-nav').find('a[href="' + location.pathname + '"]');
    $link.closest('li').addClass('active');
    $link.closest('li.dropdown').addClass('active');

    const url = document.location.toString();
    if (url.match('#')) {
        try {
            $('.nav-tabs a[href=#' + url.split('#')[1] + ']').tab('show');
        } catch (ex) {
            console.warn(ex);
        }
    }

    const $menu = $('#menu');
    if ($menu.length) {
        $menu.kendoPanelBar({
            expandMode: 'multiple',
            animation: {
                collapse: {
                    duration: 500,
                    effects: 'fadeOut',
                },
                expand: {
                    duration: 500,
                    effects: 'expandVertical fadeIn',
                },
            },
            select: function (e) {
                if (!e.item)
                    return;

                const targetHref = $(e.item).find('a')[0].href;
                const targetParts = targetHref.split('#');
                const sourceParts = location.href.split('#');
                if (targetParts[0] === sourceParts[0]) {
                    if (targetParts[1]) {
                        $('.nav-tabs a[href=#' + targetParts[1] + ']').tab('show');
                    } else {
                        location.href = targetHref;
                    }
                } else {
                    location.href = targetHref;
                }

                e.preventDefault();
            },
        });
    }

    const $links = $('a[href="' + document.location.pathname + document.location.hash + '"]');
    if ($links.length) {
        const panelBar = $menu.data('kendoPanelBar');
        $links.not('.mesitis-logo').addClass('k-state-selected');
        if ($links.parent()[0] !== $menu[0] && panelBar) {
            panelBar.expand($links.closest('ul').closest('li')[0], false);
        }
    }

    $('#toggleMenu').click(function () {
        $('#navigationMenu').toggle();
        const $mainContent = $('#mainContent');
        if ($mainContent.hasClass('js-menuVisible')) {
            $mainContent.removeClass('col-xs-9 col-sm-10');
            $mainContent.addClass('col-xs-12');
            $mainContent.removeClass('js-menuVisible');
        } else {
            $mainContent.addClass('col-xs-9 col-sm-10');
            $mainContent.addClass('js-menuVisible');
            $mainContent.removeClass('col-xs-12');
        }
    });

    us.getCurrentUser(function (data) {
        if (data.displayname) {
            $('#lnkName').text(data.displayname);
        } else {
            us.get2FaUserName(function (data) {
                if (data) {
                    $('#lnk2FaName').text(data + ' | ');
                }
            });
        }
    });

    let timeout;
    const delay = 300;
    let lastFilter: string | null = null;

    const performSearch = function () {
        const panelbar = $('#menu').data('kendoPanelBar');
        if (!panelbar) {
            return;
        }

        const filter = String($('#menuSearchTerm').val() || '');
        localStorage.setItem('canopy.engine.menuSearchTerm', filter);
        if (filter === lastFilter) {
            return;
        }

        lastFilter = filter;

        if (filter.length === 0) {
            $('li').toggleClass('nomatch', false).toggleClass('match', false);
            panelbar.collapse($('li', panelbar.element), false);
            return;
        }

        if (filter.length < 3) {
            return;
        }

        const searchRegEx = new RegExp(filter, 'i');

        $('li.category').toggleClass('nomatch', true).toggleClass('match', false);
        $('li.module').toggleClass('nomatch', true).toggleClass('match', false);

        $('#menu li.program').each(function () {
            let match;
            const $li = $(this);
            match = $li.text().match(searchRegEx);
            $li.toggleClass('match', match != null).toggleClass('nomatch', match == null);

            if (match != null) {
                $li.parentsUntil('#menu', 'li').toggleClass('match', true).toggleClass('nomatch', false);
            }
        });

        panelbar.expand($('li', panelbar.element), false);
    };

    const scheduleSearch = function () {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(function () {
            performSearch();
        }, delay);
    };

    const lastMenuSearchTerm = localStorage.getItem('canopy.engine.menuSearchTerm');
    if (lastMenuSearchTerm && lastMenuSearchTerm !== 'undefined') {
        $('#menuSearchTerm').val(lastMenuSearchTerm);
        scheduleSearch();
    }

    $('#menuSearchTerm').keyup(scheduleSearch);
    $('#menuSearchTerm').on('input', scheduleSearch);

    $('#lnkChangePwd').click(function () {
        popupRenderer.renderComponent(userCardChangePwdComponent, {
            ds: undefined,
            model: {},
            header: 'Change Password',
        });
    });

    $('#lnkResetUserSettings').click(function () {
        bootbox.confirm({
            message: 'Are you sure to clear all your saved grid settings?',
            callback: function (result) {
                if (result) {
                    us.deleteUserSettings(
                        function () {
                            bootbox.alert('User setting cleared successfully', function () {
                                location.reload();
                            });
                        },
                        function (error) {
                            bootbox.alert(kh.unwrapError(error));
                        }
                    );
                }
            },
        });
    });
});

if (config.isAuthenticated) {
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.slice(-6) === '/login' || currentUrl.indexOf('/login/') > 0 || currentUrl.indexOf('/login?') > 0) {
        window.location.href = env.appPath;
    }

    const sessionObserver = new SessionObserver();
    sessionObserver.restartTimers();
    sessionObserver.connect();

    if (!config.normalizedSessionObserverDisable) {
        const normalizationSessionObserver = new NormalizationSessionObserver({
            idleTimeout: config.normalizedSessionIdleTimeout,
            useSessionSyncAcrossTab: !config.normalizedSessionIncludeBrowserTabCheckForOpenLogs,
            callOpenLogApiOnLoad: config.normalizedSessionOpenLogOnLoad,
            pingInterval: config.normalizedSessionPingInterval,
        });
        normalizationSessionObserver.startTimer();
    }
}
